import { render, staticRenderFns } from "./regionBusiness.vue?vue&type=template&id=38f03756"
import script from "./regionBusiness.vue?vue&type=script&lang=js"
export * from "./regionBusiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports